export const GET_MARKET_ACTION_TYPE = 'market/getMarkets';

export const GET_PRODUCT_ACION_TYPE = 'product/getProducts';

export const LIMIT = { limit: 100, page: 1 };

export const MARKET_PROPS = {
  COLUMNS: {
    MARKET_ID: 'Market ID',
    MARKET_NAME: 'Market Name',
    LOCATION: 'Location',
    OPERATOR: 'Operator ID',
    STATUS: 'Status',
    CREATED: 'Created On',
    UPDATED: 'Updated On',
  },
  FILTERS: {
    STATUS_ALL: 'All',
    STATUS_ACTIVE: 'Active',
    STATUS_INACTIVE: 'Inactive',
  },
};

export const EMarketsData = [
  {
    name: 'All Markets',
    marketId: '1',
    sourceMarketId: '',
    operatorId: '',
    locationId: '',
    customerId: '',
    customerName: '',
    address: {
      city: '',
      name: '',
      state: '',
      postalCode: '',
      countryCode: '',
      addressLine1: '',
      addressLine2: '',
      addressLine3: '',
      subdivisionCode: '',
    },
    createdOn: '',
    updatedOn: '',
    marketsDropdownDisplayValue: 'All Markets',
  },
];
